/**
 *
 */
export const chunk = () =>
  import(
    /* webpackChunkName: 'markdown' */
    './Markdown'
  )
